<div class="cm-table__row">
	<ng-content select="[selector]"></ng-content>
	<div class="cm-table__row-content" [style.grid-template-columns]="gridColumns">
		<ng-content></ng-content>
	</div>
</div>
